
import AppBlacklistsIndex from "./blacklist.vue";
import AppBlacklistsList from "./list/list.vue";
import AppBlacklistsItem from "./item/item.vue";

const routes = [
  {
    path: "blacklist",
    component: AppBlacklistsIndex,
    meta: {
      auth: {
        roles: "blacklist.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "blacklist.index",
        component: AppBlacklistsList,
        meta: {
          auth: {
            roles: "blacklist.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "blacklist.create",
        component: AppBlacklistsItem,
        meta: {
          auth: {
            roles: "blacklist.create",
            redirect: { name: "blacklist.index" }
          }
        }
      },
      {
        path: ":id",
        name: "blacklist.edit",
        component: AppBlacklistsItem,
        meta: {
          auth: {
            roles: "blacklist.update",
            redirect: { name: "blacklist.index" }
          }
        }
      }
    ]
  }
];

export default routes;
